import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, inject } from '@angular/core';
import { Visualize3dObject, addComponent, getComponent, removeComponent } from 'projects/visualize3d/src/public-api';
import { FormControl, FormGroup, UntypedFormControl } from '@angular/forms';
import { Visualize3dComponentFactoryService } from 'projects/visualize3d/src/lib/providers/visualize3d-component-factory.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-object3d-editor',
  templateUrl: './object3d-editor.component.html',
  styleUrls: ['./object3d-editor.component.css'],
  standalone: false,
})
export class Object3dEditorComponent implements OnInit, OnChanges {
  private componentFactory = inject(Visualize3dComponentFactoryService);

  @Input() v3dObject: Visualize3dObject;
  @Output() componentChange = new EventEmitter();

  name = new FormControl('name', { updateOn: 'change' });
  componentTypes: string[];
  addComponentForm = new FormGroup({
    componentType: new UntypedFormControl(),
  });

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.v3dObject) {
      this.setFormValuesFrom(this.v3dObject);
      this.updateAvailableComponents();
    }
  }

  ngOnInit(): void {
    this.name.valueChanges.subscribe(name => {
      this.v3dObject.name = name;
      this.componentChange.emit();
    });
    this.addComponentForm.controls.componentType.valueChanges.subscribe(componentType => {
      this.addComponent(componentType);
      this.addComponentForm.controls.componentType.setValue(null, { emitEvent: false });
    });
  }

  setFormValuesFrom(v3dObject: Visualize3dObject): void {
    this.name.setValue(v3dObject.name, { emitEvent: false });
  }

  onComponentChange(): void {
    this.componentChange.emit();
  }

  updateAvailableComponents(): void {
    const existingComponents = this.v3dObject.components.map(c => c.type);
    const availableComponents = this.componentFactory.getAvailableComponentTypes();
    this.componentTypes = availableComponents.filter(c => !existingComponents.includes(c));
  }

  addComponent(componentType: string): void {
    this.componentFactory
      .create(componentType)
      .pipe(take(1))
      .subscribe(componentInstance => {
        addComponent(this.v3dObject, componentInstance);
        this.onComponentChange();
      });
  }

  removeComponent(componentType: string): void {
    const componentInstance = getComponent(this.v3dObject, componentType);
    removeComponent(this.v3dObject, componentInstance);
    this.onComponentChange();
  }

  trackByFn(index: number): number {
    return index;
  }
}
